export default function modal(anchor) {
    return {
        showModal: false,
        init() {
            this.$watch('showModal', (value) => {
                document.body.style.overflow = value ? 'hidden' : 'auto';
            });

            document.addEventListener('click', (event) => {
                const target = event.target.closest('a, button');
                if (target && target.getAttribute('href') === `#${anchor}`) {
                    event.preventDefault();
                    this.showModal = true;
                }
            });

            document.addEventListener("DOMContentLoaded", function () {
                const textarea = document.querySelector(".modal-form .gform-body textarea");
                if (textarea) {
                    textarea.setAttribute("rows", "2");
                }
            });
        }
    };
}